import { ButtonProps } from '../../types/ui';

export function Button({
  variant = 'primary',
  size = 'md',
  disabled = false,
  onClick,
  children,
  className = '',
  title,
}: ButtonProps) {
  const base = 'font-medium rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0a0a0f] flex items-center justify-center';

  const variants = {
    primary: 'bg-[#00d9ff] text-black hover:bg-[#33e4ff] focus:ring-[#00d9ff] hover:shadow-[0_0_20px_rgba(0,217,255,0.4)]',
    secondary: 'text-white hover:text-white focus:ring-[#00d9ff]',
    tertiary: 'bg-transparent text-[#00d9ff]/70 hover:text-[#00d9ff] hover:bg-white/5 focus:ring-[#00d9ff]',
  };

  const secondaryStyle = variant === 'secondary' ? {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
  } : {};

  const sizes = {
    sm: 'px-3 py-1.5 text-sm gap-1.5',
    md: 'px-4 py-2 text-base gap-2',
    lg: 'px-6 py-3 text-lg gap-2',
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${sizes[size]} ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      style={secondaryStyle}
      disabled={disabled}
      onClick={onClick}
      title={title}
    >
      {children}
    </button>
  );
}
